import { THEME } from 'GlobalStyles';

const STEPS_STATUS_IDS = {
  pending: 1,
  sending: 2,
  sent: 3,
  canceled: 4
};

export const STEPS_STATUS_COLOR_BY_ID = {
  [STEPS_STATUS_IDS.pending]: THEME.palette.warning.main,
  [STEPS_STATUS_IDS.sending]: THEME.palette.info.FP300,
  [STEPS_STATUS_IDS.sent]: THEME.palette.success.dark,
  [STEPS_STATUS_IDS.canceled]: THEME.palette.grey.A700,
  default: THEME.palette.grey.A700
};
